export const getKodBazowy = (kodSystemowy) => {
  if (!kodSystemowy) return ''
  return kodSystemowy.replace(/\s*\(\d+\)\s*$/, '')
}
